import type { TooltipProps } from 'antd';
import { Typography } from 'antd';
import React from 'react';

type EllipsisTypographyProps = {
  clamp?: number;
  'data-cy'?: string;
  className?: string;
  tooltipContent?: React.ReactNode;
  tooltipProps?: Omit<TooltipProps, 'title'>;
} & React.PropsWithChildren;

const EllipsisTypography: React.FC<EllipsisTypographyProps> = ({
  clamp,
  children,
  className,
  tooltipProps,
  tooltipContent,
  ...rest
}) => {
  const tooltip: TooltipProps = {
    title: tooltipContent ?? children,
    placement: 'top',
    ...tooltipProps,
  };

  if (clamp !== undefined) {
    return (
      <Typography.Paragraph ellipsis={{ rows: clamp, tooltip }} className={className} style={{ margin: 0 }} {...rest}>
        {children}
      </Typography.Paragraph>
    );
  }

  return (
    <Typography.Text ellipsis={{ tooltip }} className={className} {...rest}>
      {children}
    </Typography.Text>
  );
};

export default EllipsisTypography;
